module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ichat"
  }, [_c('div', {
    staticClass: "ichat_main_page"
  }, [_c('div', {
    ref: "mybox",
    staticClass: "detail_slide_1"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "40%",
      "left": "0",
      "right": "0",
      "bottom": "0"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "ichat_banner_title"
  }, [_vm._v("iChat")]), _vm._v(" "), _c('p', {
    staticClass: "details_banner_text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('ichat_details_page_title')) + "\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_banner_text"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('ichat_details_page_title1')) + "\n                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "Product-content mogos"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background": "#FFFFFF",
      "padding": "10% 0 10% 0"
    }
  }, [_c('Row', {
    staticStyle: {
      "padding": "0 3% 0 3%"
    }
  }, [_c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 13
    }
  }, [_c('img', {
    staticClass: "mogos-logo",
    attrs: {
      "src": require("../../assets/store/ichat.png")
    }
  })]), _vm._v(" "), _c('Col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 11
    }
  }, [_c('p', {
    staticClass: "Product-name"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('ichat_details_page_product_title')) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-price"
  }, [_vm._v("\n                                $" + _vm._s(_vm.goods_info.goods_price) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "Product-details"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('ichat_details_page_product_content')) + "\n                            ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_product_parameters1')))]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_product_parameters2')))]), _vm._v(" "), _c('li', {
    staticClass: "Product-details-li"
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_product_parameters3')))])]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.query.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Product-content speedy"
  }, [_c('div', {
    staticStyle: {
      "background": "rgba(31,45,61,0.3)",
      "padding": "25px 0 25px 0"
    }
  }, [_c('Row', {
    staticClass: "details-card",
    attrs: {
      "gutter": 30
    }
  }, [_c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon1.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content1_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content1_2')))])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon2.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content2_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content2_2')))])])])], 1), _vm._v(" "), _c('Col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon3.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content3_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content3_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon4.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content4_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content4_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon5.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content5_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content5_2')))])])])], 1), _vm._v(" "), _c('i-col', {
    staticClass: "details_card_text",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('Card', {
    staticStyle: {
      "background": "rgba(31,45,61,0.40)",
      "border": "none",
      "color": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_icon6.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content6_1')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage1_content6_2')))])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "details_iapp_banner"
  }, [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "layout-conten",
    attrs: {
      "id": "ichat_phone"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('i-col', {
    staticStyle: {
      "position": "absolute",
      "top": "0"
    },
    attrs: {
      "xs": 24,
      "sm": {
        span: 24,
        offset: 0
      },
      "md": {
        span: 12,
        offset: 11
      },
      "lg": {
        span: 12,
        offset: 11
      }
    }
  }, [_c('p', {
    staticClass: "details_iapp_text details_iapp_text1"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('iglobal_details_advantage2')) + "\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text details_iapp_text2"
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('mogos_details_page_advantage2_content')) + "\n                                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide slider1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "slider1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider2",
    attrs: {
      "id": "slider2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide slider3",
    attrs: {
      "id": "slider3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12",
      "offset": "12"
    }
  }, [_c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "40px",
      "color": "#1F2D3D",
      "line-height": "78px"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('mogos_details_page_advantage2')) + "\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text",
    staticStyle: {
      "font-size": "22px",
      "color": "#5E6D82",
      "line-height": "40px"
    }
  }, [_vm._v("\n                                            $t('mogos_details_page_advantage2_content')}}\n                                        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-ichat-phone",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticClass: "details_iapp_text details_iapp_text1"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('mogos_details_page_advantage2')) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "details_iapp_text details_iapp_text2"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('mogos_details_page_advantage2_content')) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "ichat-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("1." + _vm._s(_vm.$t('ichat_step_3')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_phone2_en.jpg"),
      "alt": "iglobal-step-1"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_phone2.png"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ichat-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("2." + _vm._s(_vm.$t('ichat_step_1')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_phone_en.png"),
      "alt": "iglobal-step-2"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/mogos_phone2.png"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ichat-step"
  }, [_c('p', {
    staticClass: "Product-smname"
  }, [_vm._v("3." + _vm._s(_vm.$t('ichat_step_2')))]), _vm._v(" "), (this.mogosLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_phone3_en.jpg"),
      "alt": "iglobal-step-3"
    }
  }) : (this.mogosLang == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/store/ichat_phone3.jpg"),
      "alt": "iglobal-step-1"
    }
  }) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Product-content detials_purchase",
    staticStyle: {
      "padding": "10% 0 10% 0"
    }
  }, [_c('Row', [_c('i-col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('p', {
    staticClass: "Product-name",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('ichat_details_page_advantage2')) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "Product-details",
    staticStyle: {
      "color": "#fff",
      "margin-top": "30px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage2_content1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ichat_details_page_advantage2_content2')))])]), _vm._v(" "), _c('button', {
    staticClass: "Product-btn",
    staticStyle: {
      "color": "#fff",
      "background-color": "#ccc",
      "border": "none"
    },
    on: {
      "click": _vm.buyNow
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('buy_now')) + "\n                                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-footer"
  }, [_c('p', {
    staticStyle: {
      "color": "#0084ff"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_notes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('shopping_notes_tip')))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-basis max_width"
  }, [_c('guess')], 1)])])])]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd716f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/ichat.vue
// module id = 834
// module chunks = 0